<p-toolbar>
  <div class="ui-toolbar-group">
    @if (show()) {
      <div id="toolbar-menu-button">
        <button
          pButton
          styleClass="menu-button"
          icon="fa fa-bars"
          (click)="menuToggle.emit($event)"
        ></button>
      </div>
    }
    <div class="menu-title">
      {{ title() }}
    </div>

    <section class="options">
      <p-select
        [options]="languageOptions"
        [(ngModel)]="selectedLanguage"
        (onChange)="onLanguageSelected($event)"
        class="language-select"
      ></p-select>
      @if (canChangeTheme) {
        <p-selectButton
          [options]="themeOptions"
          [(ngModel)]="theme"
          (onChange)="changeTheme()"
          class="theme-select"
        />
      }
    </section>
  </div>
</p-toolbar>
